class MultistepAnswers extends HTMLElement {
  constructor () {
    super()
    const dependencies = ['int-local-format', 'dec-local-format', 'phone-with-prefix']
    this.onceReady = Promise.all(dependencies.map((element) => customElements.whenDefined(element)))
    this.getValue = () => undefined
  }

  connectedCallback () {
    this.onceReady.then(() => {
      switch (this.getAttribute('view')) {
        case 'email':
          this._setupNormalInput('input[type=email]')
          break
        case 'numerico':
          this._setupNumericInput('int-local-format')
          break
        case 'decimal':
          this._setupNumericInput('dec-local-format')
          break
        case 'opcion_multiple':
          this._setupOpcionMultiple()
          break
        case 'opcion_simple':
          this._setupOpcionSimple()
          break
        case 'select_provincia':
          this._setupSelect()
          break
        case 'si_no':
          this._setupSiNo()
          break
        case 'telefono':
          this._setupTelefono()
          break
        case 'texto':
          this._setupNormalInput('input[type=text]')
          break
        case 'select_ciudad':
          this._setupSelect()
          break
        case 'codigo_postal':
          this._setupNormalInput('input[type=text]')
          break
        case 'email_con_aceptacion':
          this._setupEmailWithAcceptance()
          break
        case 'email_con_aceptaciones':
          this._setupEmailWithAcceptances()
          break
        case 'email_con_aceptacion_prestamos':
          this._setupEmailWithPartnersAcceptances()
          break
        case 'telefono_con_aceptaciones':
          this._setupPhoneWithAcceptances()
          break
        case 'telefono_con_aceptaciones_broker':
          this._setupPhoneWithAcceptances()
          break
        case 'documento_id':
          this._setupNormalInput('input[type=text]')
          break
        case 'fecha':
          this._setupDateInput('input[type=date]')
          break
      }
    })
  }

  _commonTextInputSetup (input) {
    const isValid = input.validity.valid
    this._emitValidity(isValid)

    input.addEventListener('input', () => {
      this._emitValidity(input.validity.valid)
    })
    this.addEventListener('show', function () {
      input.required = true
      this._emitValidity(input.validity.valid)
    })
    this.addEventListener('hide', function () {
      input.required = false
    })
    this._setKeyboardEvents(input, {}, false)

    this.getValue = () => input.value
  }

  _setupDateInput(selector) {
    const dateInput = this.querySelector(selector);

    if (dateInput) {
      const handleInputChange = () => {
        this._emitValidity(dateInput.value !== '');
      };

      dateInput.addEventListener('change', handleInputChange);
      dateInput.addEventListener('input', handleInputChange);

      this.addEventListener('show', () => {
        dateInput.required = true;
        handleInputChange();
      });

      this.addEventListener('hide', () => {
        dateInput.required = false;
        dateInput.value = '';
      });

      this.getValue = () => dateInput.value;
    }
  }

  _setupNumericInput (componentName) {
    const input = this.querySelector(`input[is=${componentName}]`)
    this._commonTextInputSetup(input)

    input.form.addEventListener('ajax:before', () => {
      input.removeAttribute('pattern')
      input.value = input.originalValue()
    })
  }

  _setupNormalInput (selector) {
    const input = this.querySelector(selector)
    this._commonTextInputSetup(input)
  }

  _setupOpcionMultiple () {
    const limit = parseInt(this.getAttribute('limit'))
    const checkboxes = this.querySelectorAll('input[type="checkbox"]')
    const checkeds = Array.from(checkboxes).filter((checkbox) => checkbox.checked)
    const checkedsSize = checkeds.length
    const isValid = 0 < checkedsSize <= limit

    this.getValue = () => {
      const currentlyChecked = this.querySelectorAll('input[type="checkbox"]:checked')

      return Array.from(currentlyChecked).map(input => input.value).join(',')
    }

    this._emitValidity(isValid)

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const checkedBoxes = this.querySelectorAll('input:checked')
        if (checkedBoxes.length > 0) {
          this._emitValidity(true)
          if (checkedBoxes.length > limit) {
            checkbox.checked = false
          }
        } else {
          this._emitValidity(false)
        }
      })
    })
  }

  _setupOpcionSimple () {
    const radios = this.querySelectorAll('input[type="radio"]')
    const selectedRadio = Array.from(radios).find((radio) => radio.checked)

    this.getValue = () => this.querySelector('input[type="radio"]:checked').value

    if (selectedRadio) {
      this._emitValidity(true, { go: selectedRadio.getAttribute('go') })
    }

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this._emitValidity(true, { go: radio.getAttribute('go'), auto: true })
        }
      })
    })
  }

  _setupSelect () {
    const selectProvincia = this.querySelector('select')
    const isValid = selectProvincia.selectedIndex > 0

    this.getValue = () => selectProvincia.options[selectProvincia.selectedIndex].value

    this._emitValidity(isValid)

    selectProvincia.addEventListener('change', () => {
      const isValid = selectProvincia.selectedIndex > 0
      this._emitValidity(isValid, { auto: true })
    })
  }

  _setupSiNo () {
    const siNo = this.querySelector('input[type=checkbox]')
    const isValid = siNo.checked

    this.getValue = () => siNo.checked

    this._emitValidity(isValid)

    siNo.addEventListener('change', (event) => {
      const isValid = event.target.checked
      this._emitValidity(isValid)
    })
  }

  _setupTelefono () {
    const phoneComponent = this.querySelector('phone-with-prefix')
    const phoneInput = phoneComponent.querySelector('input[type=tel]')
    const isValid = () => { return phoneInput.value.length > 0 && phoneInput.validity.valid }

    this.getValue = () => phoneComponent.inputTelefonoCompleto.value

    this._emitValidity(isValid())

    // TODO: track this listeners, both are triggered twice...
    // review `this.esValido = function () {...}`
    // at `app/cells/telephone_field/js.haml:27`
    phoneComponent.addEventListener('phone-is-valid', () => {
      // replaced `true` value with a function, but still extrange behaviour
      this._emitValidity(isValid())
    })
    phoneComponent.addEventListener('phone-is-invalid', () => {
      this._emitValidity(false)
    })

    this._setKeyboardEvents(phoneInput)
  }

  _setupEmailWithAcceptance () {
    const emailInput = this.querySelector('input[type=email]')
    const acceptance = this.querySelector('input[type=checkbox]')
    const isValid = () => { return emailInput.validity.valid && acceptance.checked }

    this.getValue = () => emailInput.value

    this._emitValidity(isValid())

    emailInput.addEventListener('input', () => {
      this._emitValidity(isValid())
    })

    acceptance.addEventListener('change', () => {
      this._emitValidity(isValid())
    })
  }

  _setupEmailWithAcceptances () {
    const emailInput = this.querySelector('input[type=email]')
    const acceptance = this.querySelector('input[type=checkbox][id=captador_simulacion_acepta_terminos]')
    const acceptanceReceiveCommercialCommunications = this.querySelector('input[type=checkbox][id=captador_simulacion_acepto_recibir_comunicaciones_comerciales]')
    const checkAllOptions = this.querySelector('input[type=checkbox][id=captador_simulacion_marcar_todas_las_opciones]')

    const isValid = () => { return emailInput.validity.valid && acceptanceReceiveCommercialCommunications.checked}

    this.getValue = () => emailInput.value

    this._emitValidity(isValid())

    emailInput.addEventListener('input', () => {
      this._emitValidity(isValid())
    })

    acceptance.addEventListener('change', () => {
      this._emitValidity(isValid())
      checkAllOptions.checked = false

      let acceptanceCesionATerceros = this.querySelectorAll('input[type=checkbox][name="captador_simulacion[clientes][]"]')

      if (acceptance.checked === false) {
        acceptanceCesionATerceros.forEach((sector) => {
          sector.checked = false
        })
      } else {
        acceptanceCesionATerceros.forEach((sector) => {
          sector.checked = true
        })
      }
    })

    acceptanceReceiveCommercialCommunications.addEventListener('change', () => {
      this._emitValidity(isValid())
      checkAllOptions.checked = false
    })

    checkAllOptions.addEventListener('change', () => {
      let clientes = document.querySelectorAll('input[type=checkbox][name="captador_simulacion[clientes][]"]')

      let clientConsent = !!checkAllOptions.checked
      acceptanceReceiveCommercialCommunications.checked = clientConsent
      acceptance.checked = clientConsent
      clientes.forEach((cliente) => {
        cliente.checked = clientConsent
      })

      setTimeout(() => {
        this._emitValidity(isValid())
      }, 500)
    })
  }

  _setupEmailWithPartnersAcceptances () {
    let emailInput = this.querySelector('input[type=email]')
    let acceptance = this.querySelector('input[type=checkbox][id=captador_simulacion_acepta_terminos]')
    let acceptanceCesionATerceros = this.querySelector('input[type=checkbox][id=captador_simulacion_aceptar_cesion_terceros]')
    let acceptancePartnersCesionATerceros = this.querySelectorAll('input[type=checkbox][name="captador_simulacion[clientes][]"]')
    let isValid = () => { return emailInput.validity.valid && acceptance.checked && acceptanceCesionATercerosChecked()}

    this.getValue = () => emailInput.value

    this._emitValidity(isValid())

    emailInput.addEventListener('input', () => {
      this._emitValidity(isValid())
    })

    acceptance.addEventListener('change', () => {
      this._emitValidity(isValid())
    })

    acceptanceCesionATerceros.addEventListener('change', () => {
      this._emitValidity(isValid())

      if (acceptanceCesionATerceros.checked === false) {
        acceptancePartnersCesionATerceros.forEach((sector) => {
          sector.checked = false
        })
      } else {
        acceptancePartnersCesionATerceros.forEach((sector) => {
          sector.checked = true
        })
      }
    })

    function acceptanceCesionATercerosChecked() {
      let acceptanceCesionATerceros = document.querySelector('input[type=checkbox][id=captador_simulacion_aceptar_cesion_terceros]')

      if (acceptanceCesionATerceros.classList.contains('hidden')) {
        return true
      } else {
        return acceptanceCesionATerceros.checked
      }
    }
  }

  _setupPhoneWithAcceptances (checkboxName = 'captador_simulacion_acepto_recibir_comunicaciones_comerciales') {
    const phoneComponent = this.querySelector('phone-with-prefix')
    const phoneInput = phoneComponent.querySelector('input[type=tel]')
    const acceptance = this.querySelector('input[type=checkbox][id=captador_simulacion_acepta_terminos]')
    const checkAllOptions = this.querySelector('input[type=checkbox][id=captador_simulacion_marcar_todas_las_opciones]')
    const acceptanceReceiveCommercialCommunications = this.querySelector('input[type=checkbox][id=captador_simulacion_acepto_recibir_comunicaciones_comerciales]')
    const acceptanceReceiveCommercialCommunicationsSectores = this.querySelector('input[type=checkbox][id=captador_simulacion_acepto_recibir_comunicaciones_comerciales_sectores]')
    const sectoresDeActividad = this.querySelectorAll('input[type=checkbox][name="captador_simulacion[sectores_actividad][]"]')
    const acceptanceToValidate = this.querySelector(`input[type=checkbox][id=${checkboxName}]`)
    const isValid = () => { return phoneInput.value.length > 0 && phoneInput.validity.valid && acceptanceToValidate.checked}

    this.getValue = () => phoneComponent.inputTelefonoCompleto.value

    this._emitValidity(isValid())

    phoneComponent.addEventListener('phone-is-valid', () => {
      this._emitValidity(isValid())
    })
    phoneComponent.addEventListener('phone-is-invalid', () => {
      this._emitValidity(false)
    })
    acceptance.addEventListener('change', () => {
      let clientes = document.querySelectorAll('input[type=checkbox][name="captador_simulacion[clientes][]"]')
      this._emitValidity(isValid())
      checkAllOptions.checked = false

      if (acceptance.checked === false) {
        clientes.forEach((cliente) => {
          cliente.checked = false
        })
      } else {
        clientes.forEach((cliente) => {
          cliente.checked = true
        })
      }
    })
    acceptanceReceiveCommercialCommunications.addEventListener('change', () => {
      this._emitValidity(isValid())
      checkAllOptions.checked = false
    })
    if (acceptanceReceiveCommercialCommunicationsSectores) {
      acceptanceReceiveCommercialCommunicationsSectores.addEventListener('change', () => {
        this._emitValidity(isValid())
        if (acceptanceReceiveCommercialCommunicationsSectores.checked === false) checkAllOptions.checked = false
        sectoresDeActividad.forEach((sector) => {
          sector.checked = acceptanceReceiveCommercialCommunicationsSectores.checked
        })
      })
    }
    checkAllOptions.addEventListener('change', () => {
      let clientes = document.querySelectorAll('input[type=checkbox][name="captador_simulacion[clientes][]"]')

      acceptanceReceiveCommercialCommunications.checked = checkAllOptions.checked
      if (acceptanceReceiveCommercialCommunicationsSectores) {
        acceptanceReceiveCommercialCommunicationsSectores.checked = checkAllOptions.checked
      }
      acceptance.checked = checkAllOptions.checked;
      sectoresDeActividad.forEach((sector) => {
        sector.checked = checkAllOptions.checked
      })
      clientes.forEach((cliente) => {
        cliente.checked = checkAllOptions.checked
      })

      setTimeout(() => {
        this._emitValidity(isValid())
      }, 500)
    })
    this._setKeyboardEvents(phoneInput)
  }

  _setKeyboardEvents (input) {
    input.addEventListener('keydown', (inputEvent) => {
      const keyCode = inputEvent.keyCode
      const isTab = keyCode === 9
      const isEnter = keyCode === 13
      if ((isEnter || isTab) && inputEvent.target.checkValidity()) {
        inputEvent.preventDefault()
        this._emitValidity(true, { auto: true })
      }
    })
  }

  _emitValidity (state, detail = {}) {
    const name = state ? 'valid' : 'invalid'
    const event = new CustomEvent(name, { bubbles: true, detail: detail })

    this.dispatchEvent(event)
  }

  get value () {
    return this.getValue()
  }
}

export default MultistepAnswers
